module.exports = __webpack_public_path__ + "img/icon_card16.e5c23be2.png";